import { ChangeDetectionStrategy, Component, EventEmitter, Input, OnInit, Output } from '@angular/core';

import { SvgLibraryIcon } from '@finnairoyj/fcom-ui-styles/enums';
import { Observable } from 'rxjs';

import { ButtonMode, ButtonSize, ButtonTheme, IconPosition, ResponsiveImage } from '@fcom/ui-components';
import { LocalDate } from '@fcom/core/utils';
import { MediaQueryService } from '@fcom/common';

import { BookingDetails } from '../../interfaces/upcoming-trips.interface';

@Component({
  selector: 'fin-upcoming-trip',
  templateUrl: './upcoming-trip.component.html',
  styleUrls: ['./upcoming-trip.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class UpcomingTripComponent implements OnInit {
  readonly ButtonMode = ButtonMode;
  readonly ButtonSize = ButtonSize;
  readonly ButtonTheme = ButtonTheme;
  readonly IconPosition = IconPosition;
  readonly SvgLibraryIcon = SvgLibraryIcon;

  @Input() image: { alt: string } & ResponsiveImage;
  @Input() departure: string;
  @Input() arrival: string;
  @Input() departureDate: LocalDate;
  @Input() bookingReference: string;
  @Input() lastName: string;
  @Input() remainingTrips: number;
  @Input() checkForUpgradesTripLink: boolean;

  @Output() viewDetailsClicked: EventEmitter<BookingDetails> = new EventEmitter();

  isMobile$: Observable<boolean>;

  tripLinkText: string;

  constructor(private mediaQueryService: MediaQueryService) {}

  onTripLinkClick(): void {
    this.viewDetailsClicked.emit({
      recLoc: this.bookingReference,
      lastName: this.lastName,
    });
  }

  ngOnInit(): void {
    this.isMobile$ = this.mediaQueryService.isBreakpoint$('mobile');
    this.tripLinkText = this.checkForUpgradesTripLink
      ? 'MMB.upcomingTrips.tripsTab.button.checkUpgrades'
      : 'MMB.upcomingTrips.tripsTab.button.viewDetails';
  }
}
